"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "help-phases-container" };
const _hoisted_2 = {
    for: "initial-draft",
    class: "first"
};
const _hoisted_3 = { for: "generation" };
const _hoisted_4 = { for: "initial-research" };
const _hoisted_5 = { for: "research-phase" };
const _hoisted_6 = {
    for: "action-phase",
    class: "last"
};
const _hoisted_7 = { for: "production-phase" };
const _hoisted_8 = { for: "solar-phase" };
const _hoisted_9 = { for: "end-game" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("ul", null, [
            (0, vue_1.createElementVNode)("li", null, [
                _cache[8] || (_cache[8] = (0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    id: "initial-draft"
                }, null, -1)),
                (0, vue_1.createElementVNode)("label", _hoisted_2, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[0] || (_cache[0] = [
                            (0, vue_1.createTextVNode)("Initial Drafting (optional variant)", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                (0, vue_1.createElementVNode)("ul", null, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[1] || (_cache[1] = [
                            (0, vue_1.createTextVNode)("Draw 3 corporation cards", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[2] || (_cache[2] = [
                                (0, vue_1.createTextVNode)("Draw 4 prelude cards", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        _cache[3] || (_cache[3] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-prelude" }, null, -1))
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[4] || (_cache[4] = [
                            (0, vue_1.createTextVNode)("Draw 5 project cards. Draft. Pick one card and pass to the player above in turn order. Repeat until you have 5 cards.", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[5] || (_cache[5] = [
                            (0, vue_1.createTextVNode)("Draw 5 more project cards. Draft and pass to the player below in turn order instead.", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[6] || (_cache[6] = [
                                (0, vue_1.createTextVNode)("Draft the prelude cards. Pick one card and pass to the player above in turn order. Repeat until you have 4 preludes.", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        _cache[7] || (_cache[7] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-prelude" }, null, -1))
                    ])
                ])
            ]),
            (0, vue_1.createElementVNode)("li", null, [
                _cache[74] || (_cache[74] = (0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    id: "generation"
                }, null, -1)),
                (0, vue_1.createElementVNode)("label", _hoisted_3, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[9] || (_cache[9] = [
                            (0, vue_1.createTextVNode)("Each generation", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                (0, vue_1.createElementVNode)("ul", null, [
                    (0, vue_1.createElementVNode)("li", null, [
                        _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            id: "initial-research"
                        }, null, -1)),
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", _hoisted_4, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[10] || (_cache[10] = [
                                    (0, vue_1.createTextVNode)("Initial Research Phase (Generation 1 only)", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ])), [
                            [_directive_i18n]
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[11] || (_cache[11] = [
                                    (0, vue_1.createTextVNode)("Select which corporation, 2 preludes and project cards to keep.", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[12] || (_cache[12] = [
                                    (0, vue_1.createTextVNode)("In turn order, play the corporation and pay 3 M€ for each of the project cards bought.", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.createElementVNode)("li", null, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[13] || (_cache[13] = [
                                        (0, vue_1.createTextVNode)("In turn order, play both preludes.", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[14] || (_cache[14] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-prelude" }, null, -1))
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        _cache[20] || (_cache[20] = (0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            id: "research-phase"
                        }, null, -1)),
                        (0, vue_1.createElementVNode)("label", _hoisted_5, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[16] || (_cache[16] = [
                                    (0, vue_1.createTextVNode)("Research Phase (Generation 2+)", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[17] || (_cache[17] = [
                                    (0, vue_1.createTextVNode)("Draw four project cards", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[18] || (_cache[18] = [
                                    (0, vue_1.createTextVNode)("(Optional variant: draft the cards. Pick one pass to the player below in even generation and above in odd generation. Repeat until you have four cards.)", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[19] || (_cache[19] = [
                                    (0, vue_1.createTextVNode)("Decide how many cards to buy", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        _cache[39] || (_cache[39] = (0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            id: "action-phase"
                        }, null, -1)),
                        (0, vue_1.createElementVNode)("label", _hoisted_6, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[21] || (_cache[21] = [
                                    (0, vue_1.createTextVNode)("Action phase", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[23] || (_cache[23] = (0, vue_1.createTextVNode)(" (", -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[22] || (_cache[22] = [
                                    (0, vue_1.createTextVNode)("Turmoil policy in effect", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            _cache[24] || (_cache[24] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-turmoil" }, null, -1)),
                            _cache[25] || (_cache[25] = (0, vue_1.createTextVNode)(" ) ", -1))
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.createElementVNode)("li", null, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[26] || (_cache[26] = [
                                        (0, vue_1.createTextVNode)("Take 1 or 2 actions (mandatory 2 actions if playing with fast mode):", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                (0, vue_1.createElementVNode)("ul", null, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[27] || (_cache[27] = [
                                            (0, vue_1.createTextVNode)("play card", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[28] || (_cache[28] = [
                                            (0, vue_1.createTextVNode)("use active card action", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[29] || (_cache[29] = [
                                            (0, vue_1.createTextVNode)("standard project", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[30] || (_cache[30] = [
                                            (0, vue_1.createTextVNode)("convert plants to greenery", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[31] || (_cache[31] = [
                                            (0, vue_1.createTextVNode)("convert heat to temperature", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[32] || (_cache[32] = [
                                            (0, vue_1.createTextVNode)("claim milestone", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[33] || (_cache[33] = [
                                            (0, vue_1.createTextVNode)("fund award", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.createElementVNode)("li", null, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[34] || (_cache[34] = [
                                                (0, vue_1.createTextVNode)("trade with 9 M€, 3 Ti, or 3 energy", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        _cache[35] || (_cache[35] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-colony" }, null, -1))
                                    ]),
                                    (0, vue_1.createElementVNode)("li", null, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[36] || (_cache[36] = [
                                                (0, vue_1.createTextVNode)("send delegate: free from lobby, 5 M€ from reserve", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        _cache[37] || (_cache[37] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-turmoil" }, null, -1))
                                    ])
                                ])
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[38] || (_cache[38] = [
                                    (0, vue_1.createTextVNode)("Pass for the generation", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        _cache[43] || (_cache[43] = (0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            id: "production-phase"
                        }, null, -1)),
                        (0, vue_1.createElementVNode)("label", _hoisted_7, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[40] || (_cache[40] = [
                                    (0, vue_1.createTextVNode)("Production Phase", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[41] || (_cache[41] = [
                                    (0, vue_1.createTextVNode)("Energy becomes heat", -1)
                                ]))])), [
                                [_directive_i18n]
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[42] || (_cache[42] = [
                                    (0, vue_1.createTextVNode)("Produce resources", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        _cache[73] || (_cache[73] = (0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            id: "solar-phase"
                        }, null, -1)),
                        (0, vue_1.createElementVNode)("label", _hoisted_8, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[44] || (_cache[44] = [
                                    (0, vue_1.createTextVNode)("Solar Phase", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (0, vue_1.createElementVNode)("ul", null, [
                            (0, vue_1.createElementVNode)("li", null, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[45] || (_cache[45] = [
                                        (0, vue_1.createTextVNode)("i. Game end check", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                (0, vue_1.createElementVNode)("ul", null, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[46] || (_cache[46] = [
                                            (0, vue_1.createTextVNode)("If temperature, oxygen, and oceans are maxed, skip the rest of solar phase to the end game phase.", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[47] || (_cache[47] = [
                                            (0, vue_1.createTextVNode)("(If playing solo, the game ends after 14 generations.)", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[48] || (_cache[48] = [
                                            (0, vue_1.createTextVNode)("Solo mode adjustments for expansions:", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[49] || (_cache[49] = [
                                            (0, vue_1.createTextVNode)("• Prelude: The game ends 2 generations earlier.", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[50] || (_cache[50] = [
                                            (0, vue_1.createTextVNode)("• Venus Next: The Venus track must be completed for solo mode victory.", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[51] || (_cache[51] = [
                                            (0, vue_1.createTextVNode)("• The Moon (63TR condition): No changes.", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[52] || (_cache[52] = [
                                            (0, vue_1.createTextVNode)("• The Moon (Terraforming condition): The game ends 2 generations later. The Moon must tracks must be completed for solo mode victory.", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ]),
                            (0, vue_1.createElementVNode)("li", null, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[53] || (_cache[53] = [
                                        (0, vue_1.createTextVNode)("ii. World Government Terraforming (start player chooses)", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[54] || (_cache[54] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-venus" }, null, -1))
                            ]),
                            (0, vue_1.createElementVNode)("li", null, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[55] || (_cache[55] = [
                                        (0, vue_1.createTextVNode)("iii. Colony production", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                (0, vue_1.createElementVNode)("ul", null, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[56] || (_cache[56] = [
                                            (0, vue_1.createTextVNode)("Trade fleets return", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[57] || (_cache[57] = [
                                            (0, vue_1.createTextVNode)("Each colony tile track is increased 1 step if possible", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ])
                            ]),
                            (0, vue_1.createElementVNode)("li", null, [
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[58] || (_cache[58] = [
                                        (0, vue_1.createTextVNode)("iv. Turmoil", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ]),
                                _cache[72] || (_cache[72] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-turmoil" }, null, -1)),
                                (0, vue_1.createElementVNode)("ul", null, [
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[59] || (_cache[59] = [
                                            (0, vue_1.createTextVNode)("1. TR Revision: All players lose 1 TR", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[60] || (_cache[60] = [
                                            (0, vue_1.createTextVNode)("2. Global Event: Perform the current Global Event", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ]),
                                    (0, vue_1.createElementVNode)("li", null, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[61] || (_cache[61] = [
                                                (0, vue_1.createTextVNode)("3. New Government", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        (0, vue_1.createElementVNode)("ul", null, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[62] || (_cache[62] = [
                                                    (0, vue_1.createTextVNode)("Change policy tile", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[63] || (_cache[63] = [
                                                    (0, vue_1.createTextVNode)("Perform the ruling bonus of the dominant party", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[64] || (_cache[64] = [
                                                    (0, vue_1.createTextVNode)("The dominant party leader becomes chairman, earning 1 TR.", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[65] || (_cache[65] = [
                                                    (0, vue_1.createTextVNode)("Move the old chairman and all other delegates from the dominant party to the reserves.", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[66] || (_cache[66] = [
                                                    (0, vue_1.createTextVNode)("Shift the dominance marker. In case of tie, the party closest to the left of the previous dominant party becomes dominant.", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[67] || (_cache[67] = [
                                                    (0, vue_1.createTextVNode)("Restore lobby", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ])
                                        ])
                                    ]),
                                    (0, vue_1.createElementVNode)("li", null, [
                                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[68] || (_cache[68] = [
                                                (0, vue_1.createTextVNode)("4. Changing Times", -1)
                                            ]))])), [
                                            [_directive_i18n]
                                        ]),
                                        (0, vue_1.createElementVNode)("ul", null, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[69] || (_cache[69] = [
                                                    (0, vue_1.createTextVNode)("Move the coming (middle) Global Event to current position (right). Add its lower neutral delegate.", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[70] || (_cache[70] = [
                                                    (0, vue_1.createTextVNode)("Move the distant (left) Global Event to coming position (middle)", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ]),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[71] || (_cache[71] = [
                                                    (0, vue_1.createTextVNode)("Reveal a new Global Event in the distant (left) position. Add its top neutral delegate", -1)
                                                ]))])), [
                                                [_directive_i18n]
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            (0, vue_1.createElementVNode)("li", null, [
                _cache[81] || (_cache[81] = (0, vue_1.createElementVNode)("input", {
                    type: "checkbox",
                    id: "end-game"
                }, null, -1)),
                (0, vue_1.createElementVNode)("label", _hoisted_9, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[75] || (_cache[75] = [
                            (0, vue_1.createTextVNode)("End Game", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                ]),
                (0, vue_1.createElementVNode)("ul", null, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[76] || (_cache[76] = [
                            (0, vue_1.createTextVNode)("In turn order, convert plants to greeneries.", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", null, [...(_cache[77] || (_cache[77] = [
                            (0, vue_1.createTextVNode)("Assign awards", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.createElementVNode)("li", null, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[78] || (_cache[78] = [
                                (0, vue_1.createTextVNode)("Score: TR + tiles + card + milestones + awards + (1 VP per chairman and party leader", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        _cache[79] || (_cache[79] = (0, vue_1.createElementVNode)("div", { class: "expansion-icon expansion-icon-turmoil" }, null, -1)),
                        _cache[80] || (_cache[80] = (0, vue_1.createTextVNode)(") ", -1))
                    ])
                ])
            ])
        ])
    ]));
}
